import { BigNumber } from '@ethersproject/bignumber'
import { BN_ZERO } from './bigNumber'

// formula comes from: https://github.com/ethers-io/ethers.js/blob/master/packages/abstract-provider/src.ts/index.ts#L247
export function getSuggestedMaxGasFee(baseFee: BigNumber, gasTip: BigNumber) {
  return baseFee.mul(2).add(gasTip)
}

export function getGasPriceFromFees(baseFee: BigNumber, gasTip: BigNumber) {
  return baseFee.add(gasTip)
}

export function getGasTipFromMaxGasFee(maxGasFee: BigNumber, baseFee: BigNumber) {
  const doubledBaseFee = baseFee.mul(2)
  return maxGasFee.gt(doubledBaseFee) ? maxGasFee.sub(doubledBaseFee) : BN_ZERO
}

export function getGasTipFromGasPrice(gasPrice: BigNumber, baseFee: BigNumber) {
  return gasPrice.gt(baseFee) ? gasPrice.sub(baseFee) : BN_ZERO
}
